import randFloat from "./randFloat";

// range: [low, high] - inclusive of low and high
function randIntBetween(low: number, high: number) {
  return Math.floor(randFloat() * (high - low + 1)) + low;
}

export default randIntBetween;
